import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

export default function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background-50">
      <div className="relative hidden lg:block overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,#E25A3C_0%,transparent_40%),linear-gradient(165deg,#3b241c_0%,#8a4a38_50%,#f3e6d8_100%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-primary-950/80" />
        <div className="relative z-10 h-full p-10 flex flex-col justify-between">
          <Link to="/">
            <Logo dark={false} />
          </Link>
          <div>
            <h2 className="font-heading text-4xl font-bold text-background-50 leading-tight">
              一眼看懂
              <br />
              谁在访问你的网站
            </h2>
            <p className="mt-4 text-background-100/85 max-w-md leading-relaxed">
              注册后添加站点、粘贴一行统计代码，即可查看访问量、来源渠道与地域分布。
            </p>
          </div>
          <p className="text-xs text-background-100/70">© 2026 StatFlow</p>
        </div>
      </div>

      <div className="flex flex-col px-4 py-8 md:px-10">
        <div className="lg:hidden mb-8">
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <div className="w-full max-w-md">
            <h1 className="font-heading text-3xl font-bold text-foreground-950">{title}</h1>
            <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
